
import { Link } from 'react-router-dom';
import { products } from '../../../mocks/products';

export default function FeaturedProducts() {
  // 베스트셀러 제품 선정: 현대 기아 라이트 기준
  const featuredProducts = [
    products.find(p => p.id === 'h100-1'),      // HYUNDAI H100 HEAD LAMP
    products.find(p => p.id === 'HDS001'),       // HYUNDAI HD 시리즈 HEAD LAMP
    products.find(p => p.id === 'por-1'),         // HYUNDAI PORTER HEAD LAMP
    products.find(p => p.id === 'STA001'),        // HYUNDAI STAREX HEAD LAMP
    products.find(p => p.id === 'bongo3-1'),      // KIA BONGO 3 HEAD LAMP
    products.find(p => p.id === 'COU001'),        // HYUNDAI COUNTY HEAD LAMP
  ].filter(Boolean);

  return (
    <section id="featured" className="py-16 md:py-24 lg:py-32 bg-[#F8F9FA]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-16 lg:mb-20">
          <div className="inline-block px-5 md:px-8 py-2 md:py-3 bg-[#1A1A2E] mb-4 md:mb-8 rounded-md">
            <span
              className="text-white text-xs md:text-base font-bold tracking-widest"
              style={{ fontFamily: "'Anton', sans-serif" }}
            >
              인기 제품
            </span>
          </div>

          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A2E] mb-3 md:mb-6 leading-tight"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            베스트셀러 라이트
          </h2>

          <p
            className="text-sm md:text-base lg:text-lg text-[#4A4A5A] max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            현대 · 기아 차종별 인기 헤드램프를 확인하세요. 모든 제품은 순정 규격으로
            완벽한 호환성을 보장합니다.
          </p>
        </div>

        <div
          className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6 lg:gap-8"
          data-product-shop
        >
          {featuredProducts.map(product => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              <div className="relative h-[160px] sm:h-[200px] md:h-[240px] lg:h-[280px] overflow-hidden bg-gray-50">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-2 right-2 md:top-4 md:right-4 px-2 md:px-3 py-0.5 md:py-1 bg-[#E63946] text-white text-[10px] md:text-xs font-bold rounded-full whitespace-nowrap">
                  BEST
                </div>
              </div>

              <div className="p-3 sm:p-4 md:p-5 lg:p-6">
                <div className="flex items-center gap-1.5 md:gap-2 mb-2 md:mb-3">
                  <span
                    className="text-[#E63946] text-[10px] md:text-xs font-bold px-1.5 md:px-2 py-0.5 md:py-1 bg-red-50 rounded truncate max-w-[140px] md:max-w-none"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {product.name}
                  </span>
                </div>

                <h3
                  className="text-sm sm:text-base md:text-lg font-bold text-[#1A1A2E] mb-1 md:mb-2 line-clamp-1 leading-snug"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {product.description}
                </h3>

                <p
                  className="text-[10px] md:text-xs text-gray-400 mb-2 md:mb-3 line-clamp-1"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {product.category}
                </p>

                <div className="mb-2 md:mb-4 hidden sm:block">
                  <p className="text-[10px] md:text-xs text-gray-500 mb-1 md:mb-2 font-medium">
                    부품번호
                  </p>
                  <span
                    className="text-[10px] md:text-xs px-1.5 md:px-2 py-0.5 md:py-1 bg-[#1A1A2E]/5 text-[#1A1A2E] rounded inline-block truncate max-w-full"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {product.partNumber}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-2 md:pt-4 border-t border-gray-100">
                  <p
                    className="text-xs sm:text-sm md:text-base text-[#E63946] font-bold"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    가격문의
                  </p>
                  <span className="text-xs text-gray-400 group-hover:text-[#E63946] transition-colors hidden sm:inline">
                    자세히 →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-16 lg:mt-20">
          <Link
            to="/shop"
            className="inline-block px-10 md:px-16 py-3.5 md:py-5 bg-[#1A1A2E] text-white text-base md:text-xl font-bold tracking-widest hover:bg-[#E63946] transition-colors duration-300 cursor-pointer whitespace-nowrap rounded-md"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            전체 제품 보기
          </Link>
        </div>
      </div>
    </section>
  );
}
